import { Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
// import Watoms from "./pages/Watoms";
// import Eivots from "../pages/Eivots";
import WatomsUserProfile from "../pages/WatomsUserProfile";
import WatomsSystemInfo from "../pages/WatomsSystemInfo";
import TomsPms from "../pages/TomsPms";
import TomsForm from "../pages/TomsForm";
import TraineeAbsence from "../pages/TraineeAbsence";
import InistituteIncident from "../pages/InistitueIncident";
import TomsInterview from "../pages/TomsInterview";
import TomsDms from "../pages/TomsDms";
import TomsUploadDocument from "../pages/TomsUploadDocument";
import TomsViewDocument from "../pages/TomsViewDocument";
import WatomsTmsDashboard from "../pages/watoms/tms/WatomsTmsDashboard";
// import { AlarmProvider } from "../context/AlarmContext";
import WatomsMyTasks from "../pages/WatomsMyTasks";
// import WatomsTmsMyTasks from "../pages/WatomsTmsMyTasks";
import WatomsTmsAddTask from "../pages/WatomsTmsAddTask";
import WatomsTmsEdit from "../pages/watoms/tms/WatomsTmsEdit";
import TomsAssign from "../pages/TomsAssign";
import TomsViewTask from "../pages/TomsViewTask";
import WatomsDashboard from "../pages/watoms/WatomsDashboard";
import WatomsNews from "../pages/WatomsNews";
import WatomsPublishNews from "../pages/WatomsPublishNews";
import WatomsManagersReports from "../pages/WatomsManagersReports";
import WatomsProfessionalExamination from "../pages/watoms/professional_examination/WatomsProfessionalExamination";
import WatomsPEObserverEvaluation from "../pages/watoms/professional_examination/WatomsPEObserverEvaluation";
import WatomsPEQGObserversEvaluation from "../pages/watoms/professional_examination/WatomsPEQGObserversEvaluation";
import WatomsPECandidatesExam from "../pages/watoms/professional_examination/WatomsPECandidatesExam";
import WatomsPEDashboard from "../pages/watoms/professional_examination/WatomsPEDashboard";
import WatomsPMSPerformanceReport from "pages/watoms/pms/WatomsPMSPerformanceReport";
import WatomsMainPage from "pages/watoms/WatomsMainPage";
import WatomsPdms from "pages/watoms/pdms/WatomsPdms";
import WatomsPECandidateProfile from "pages/watoms/professional_examination/WatomsPECandidateProfile";
import GraduatesDashboard from "pages/GraduatesDashboard";
import ApplicantsDashboard from "pages/ApplicantsDashboard";
import WatomsHelperPage from "pages/watoms/WatomsHelperPage";
import EbdaEduWatomsWorkshopReport from "pages/ebdaedu/EbdaEduWatomsWorkshopReport";
import WatomsPdmsDashboard from "pages/watoms/pdms/WatomsPdmsDashboard";

export const WatomsRoutes = () => [
    // checked 2/3 (rady)
    <Route key="watoms" path="/watoms" element={
        <ProtectedRoute>
            <WatomsMainPage />
        </ProtectedRoute>
    } />,
    // checked 2/3 (rady)
    <Route key="watoms helper" path="/watoms/helper" element={
        <ProtectedRoute>
            <WatomsHelperPage />
        </ProtectedRoute>
    } />,
    // postponed for future use
    <Route key="watoms user profile" path="/watoms/user-profile" element={
        <ProtectedRoute>
            <WatomsUserProfile />
        </ProtectedRoute>
    } />,
    // postponed for future use
    <Route key="watoms system info" path="/watoms/system-info" element={
        <ProtectedRoute>
            <WatomsSystemInfo />
        </ProtectedRoute>
    } />,
    // checked 2/3 (rady) "still needs more checking"
    <Route key="watoms PMS" path="/watoms/pms" element={
        <ProtectedRoute>
            <TomsPms />
        </ProtectedRoute>
    } />,
    // checked 4/3 (rady) "still needs more checking"
    <Route key="watoms PMS form" path="/watoms/pms/form/:id" element={
        <ProtectedRoute>
            <TomsForm />
        </ProtectedRoute>
    } />,
    // checked 4/3 (rady)
    <Route key="watoms PMS trainee absence" path="/watoms/pms/trainee-absence" element={
        <ProtectedRoute>
            <TraineeAbsence />
        </ProtectedRoute>
    } />,
    // checked 4/3 (rady)
    <Route key="watoms PMS inistitute incident" path="/watoms/pms/inistitute-incident" element={
        <ProtectedRoute>
            <InistituteIncident />
        </ProtectedRoute>
    } />,
    // checked 5/3 (rady)
    <Route key="watoms PMS performance Report" path="/watoms/pms/performance-report" element={
        <ProtectedRoute>
            <WatomsPMSPerformanceReport />
        </ProtectedRoute>
    } />,
    // checked 5/3 (rady) still needs another checkup
    <Route key="watoms DMS" path="/watoms/dms" element={
        <ProtectedRoute>
            <TomsDms />
        </ProtectedRoute>
    } />,
    // checked 5/3 (rady) still needs another checkup
    <Route key="watoms DMS upload" path="/watoms/dms/upload" element={
        <ProtectedRoute>
            <TomsUploadDocument />
        </ProtectedRoute>
    } />,
    // checked 5/3 (rady)
    <Route key="watoms DMS view" path="/watoms/dms/view/:id" element={
        <ProtectedRoute>
            <TomsViewDocument />
        </ProtectedRoute>
    } />,
    // removed alarm provider for now as it is still not finished
    // need to add loading screen
    // checked 10/3 (rady) still needs another checkup
    <Route key="watoms TMS" path="/watoms/tms" element={
        <ProtectedRoute>
            {/* <AlarmProvider> */}
            <WatomsTmsDashboard />
            {/* </AlarmProvider> */}
        </ProtectedRoute>
    } />,
    // checked 10/3 (rady) still needs another checkup
    <Route key="watoms TMS my tasks" path="/watoms/tms/my-tasks" element={
        <ProtectedRoute>
            <WatomsMyTasks />
        </ProtectedRoute>
    } />,
    <Route key="watoms Tms add task" path="/watoms/tms/add-task" element={
        <ProtectedRoute>
            <WatomsTmsAddTask />
        </ProtectedRoute>
    } />,
    <Route key="watoms TMS edit task" path="/watoms/tms/edit/:id" element={
        <ProtectedRoute>
            <WatomsTmsEdit />
        </ProtectedRoute>
    } />,
    <Route key="watoms TMS assign" path="/watoms/tms/assign" element={
        <ProtectedRoute>
            <TomsAssign />
        </ProtectedRoute>
    } />,
    <Route key="watoms TMS view" path="/watoms/tms/view/:id" element={
        <ProtectedRoute>
            <TomsViewTask />
        </ProtectedRoute>
    } />,
    <Route key="watoms Dashboard" path="/watoms/dashboard" element={
        <ProtectedRoute>
            <WatomsDashboard />
        </ProtectedRoute>
    } />,
    <Route key="watoms news" path="/watoms/news" element={
        <ProtectedRoute>
            <WatomsNews />
        </ProtectedRoute>
    } />,
    <Route key="watoms publish news" path="/watoms/publish-news" element={
        <ProtectedRoute>
            <WatomsPublishNews />
        </ProtectedRoute>
    } />,
    <Route key="watoms managers" path="/watoms/managers" element={
        <ProtectedRoute>
            <WatomsManagersReports />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE" path="/watoms/pe" element={
        <ProtectedRoute>
            <WatomsProfessionalExamination />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE QRCode Candidate Profile" path="/watoms/pe/candidate-profile/:id" element={
        <ProtectedRoute>
            <WatomsPECandidateProfile />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE observer evaluation" path="/watoms/pe/observer-evaluation/:id" element={
        <ProtectedRoute>
            <WatomsPEObserverEvaluation />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE QG observers evaluation" path="/watoms/pe/qg-observers-evaluation/:id" element={
        <ProtectedRoute>
            <WatomsPEQGObserversEvaluation />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE candidates exam" path="/watoms/pe/candidates-exam/:id" element={
        <ProtectedRoute>
            <WatomsPECandidatesExam />
        </ProtectedRoute>
    } />,
    <Route key="watoms PE Dashboard" path="/watoms/pe/dashboard" element={
        <ProtectedRoute>
            <WatomsPEDashboard />
        </ProtectedRoute>
    } />,
    <Route key="watoms Graduate" path="/graduates-dashboard" element={
        <ProtectedRoute>
            <GraduatesDashboard />
        </ProtectedRoute>
    } />,
    <Route key="watoms Applicants" path="/applicants-dashboard" element={
        <ProtectedRoute>
            <ApplicantsDashboard />
        </ProtectedRoute>
    } />,
    <Route key="watoms PDMS Home Page" path="/watoms/pdms" element={
        <ProtectedRoute>
            <WatomsPdms />
        </ProtectedRoute>
    } />,
    <Route key="watoms PDMS Dashboard" path="/watoms/pdms/dashboard" element={
        <ProtectedRoute>
            <WatomsPdmsDashboard />
        </ProtectedRoute>
    } />,
    <Route key="watoms PDMS interview" path="/watoms/pdms/interview" element={
        <ProtectedRoute>
            <TomsInterview />
        </ProtectedRoute>
    } />,
    <Route key="watoms workshop report" path="/watoms/workshop-report" element={
        <ProtectedRoute>
            <EbdaEduWatomsWorkshopReport />
        </ProtectedRoute>
    } />,
];